import { lazy } from "react";
import { createBrowserRouter, Navigate, Outlet, redirect } from "react-router-dom";

// import { RootState, store } from "@store/store";
import { MainLayout } from "@layouts/MainLayout";
import RutaProtegida from "@components/atoms/RutaProtegida.tsx";
import { BajoConstruccion } from "@components/BajoConstruccion.tsx";
// import { useSelector } from "react-redux";

const Login = lazy(() => import("@pages/Login"));
const Solicitudes = lazy(() => import("@pages/Solicitudes"));
const WhiteZone = lazy(() => import("@pages/Solicitud/WhiteZone"));
// const Solicitud = lazy(() => import("@pages/Solicitud/Solicitud"));

const InfoGeneral = lazy(() => import("@pages/Solicitud/secciones/InfoGeneral/InfoGral"));
const PerfilCrediticio = lazy(() => import("@pages/Solicitud/secciones/PerfilFinanciero/PerfilCrediticio"));
const RpcPld = lazy(() => import("@pages/Solicitud/secciones/RpcPld/RpcPld"));
const Dictamen = lazy(() => import("@pages/Solicitud/secciones/Dictamen/Dictamen"));
const Dispersion = lazy(() => import("@pages/Solicitud/secciones/CarteraDispersion/Dispersion"));
const Expediente = lazy(() => import("@pages/Solicitud/secciones/Expediente/Expediente"));
const PldIntegral = lazy(() => import("@pages/Solicitud/secciones/PldIntegral/PldIntegral"));
const VisitaOcular = lazy(() => import("@pages/Solicitud/secciones/VisitaOcular/VisitaOcular"));
const RevisionControl = lazy(() => import("@pages/Solicitud/secciones/RevisionControl/RevisionControl"));
const ResumenOperacion = lazy(() => import("@pages/Solicitud/secciones/ResumenOperacion/ResumenOperacion"));
const Contractuales = lazy(() => import("@pages/Solicitud/secciones/Contractuales/Contractuales"));
const ValidacionCrediticia = lazy(() => import("@pages/Solicitud/secciones/ValidacionCrediticia/ValidacionCrediticia"));
const RiesgoIdentidad = lazy(() => import("@pages/Solicitud/secciones/RiesgoIdentidad/RiesgoIdentidad"));
const Oferta = lazy(() => import("@pages/Solicitud/secciones/Oferta/Oferta"));

const Usuarios = lazy(() => import("@pages/admin/secciones/Usuarios/Usuarios"));
const Financieras = lazy(() => import("@pages/admin/secciones/Financieras/Financieras"));
const RolesPermisos = lazy(() => import("@pages/admin/secciones/RolesPermisos/RolesPermisos"));
const ReglasAdmision = lazy(() => import("@pages/admin/secciones/ReglasAdmision/ReglasAdmision"));
const CodigosAtribucionV2 = lazy(() => import("@pages/admin/secciones/CodigosAtribucion/CodigosAtribucionV2"));
const ReglasAdmisionFinancieras = lazy(
    () => import("@pages/admin/secciones/ReglasAdmisionFinancieras/ReglasAdmisionFinancieras"),
);

// const permissions = useSelector((state: RootState) => state.app.session.permissionsV2);
// const permissions = (state = store.getState()) => state.app.session.permissionsV2;

const router = createBrowserRouter([
    {
        element: <RutaProtegida />,
        children: [
            {
                Component: MainLayout,
                path: "/solicitudes",
                errorElement: <WhiteZone error />,
                children: [
                    {
                        index: true,
                        Component: Solicitudes,
                        loader: ({ request }) => {
                            const url = new URL(request.url);
                            if (/^\/(?:solicitudes|admin)\/$/.test(url.pathname)) {
                                return redirect(url.pathname.replace(/\/+$/, ""));
                            }
                        },
                    },
                    {
                        path: ":companyName/:id",
                        Component: () => <Outlet />,
                        children: [
                            {
                                index: true,
                                Component: InfoGeneral,
                            },
                            { path: "perfil_financiero", Component: PerfilCrediticio },
                            { path: "perfil_legal", Component: RpcPld },
                            { path: "oferta", Component: Oferta },
                            { path: "dictamen_legal", Component: Dictamen },
                            { path: "expediente", Component: Expediente },
                            { path: "validacion_crediticia", Component: ValidacionCrediticia },
                            { path: "riesgo_identidad", Component: RiesgoIdentidad },
                            { path: "pld_integral", Component: PldIntegral },
                            { path: "visita_integral", Component: VisitaOcular },
                            { path: "revision_control", Component: RevisionControl },
                            { path: "contractuales", Component: Contractuales },
                            { path: "cartera_dispersion", Component: Dispersion },
                            { path: "resumen", Component: ResumenOperacion },
                        ],
                    },
                ],
            },
        ],
    },
    {
        element: <RutaProtegida permissionCodes={["MADMIN"]} />,
        children: [
            {
                Component: MainLayout,
                path: "/admin",
                children: [
                    {
                        index: true,
                        Component: Usuarios,
                        loader: ({ request }) => {
                            const url = new URL(request.url);
                            if (/^\/(?:solicitudes|admin)\/$/.test(url.pathname)) {
                                return redirect(url.pathname.replace(/\/+$/, ""));
                            }
                        },
                    },
                    {
                        Component: RolesPermisos,
                        path: "roles",
                    },
                    {
                        Component: Financieras,
                        path: "financieras",
                    },
                    {
                        Component: CodigosAtribucionV2,
                        path: "codigos_atribucion",
                    },
                    {
                        Component: BajoConstruccion,
                        path: "estructura_atribucion",
                    },
                    {
                        Component: ReglasAdmision,
                        path: "abortivos_revision",
                    },
                    {
                        Component: ReglasAdmisionFinancieras,
                        path: "abortivos_revision_financieras",
                    },
                    {
                        Component: BajoConstruccion,
                        path: "log_actividad",
                    },
                ],
            },
        ],
    },
    {
        Component: Login,
        errorElement: <WhiteZone error />,
        path: "/",
    },
    {
        path: "*",
        // Component: WhiteZone,
        element: <Navigate to="/" replace />,
    },
]);

export default router;
